import React from 'react';
import ScaledImage from '../../generalPurpose/ScaledImage';
import {SizeMe} from 'react-sizeme';
import {Container} from '@mui/material';

type Props = {
  contentURL: string;
};

export default function POCToolImgContent(props: Props) {
  const {contentURL} = props;

  return (
    <Container style={styles.container}>
      <SizeMe>
        {({size}) => (
          <ScaledImage
            uri={contentURL}
            width={size.width}
            height={size.height}
          />
        )}
      </SizeMe>
    </Container>
  );
}

const styles = {
  container: {
    paddingBottom: 10,
  },
};
